// @flow
import React, { type Node, useCallback } from 'react';
import cn from 'classnames/bind';

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './Tab.scss';


const TASK: 'task' = 'task'; // вкладка с заданиями
const THEME: 'theme' = 'theme'; // вкладка с темами урока
const BELLS: 'bells' = 'bells'; // вкладка с расписанием звонков
const ROOM: 'room' = 'room';

export const availableTabs = { TASK, THEME, BELLS, ROOM };
type TabType = $Values<typeof availableTabs>

const cx = cn.bind(styles);

type Props = {
  id: TabType,
  children: string,
  active: boolean,
  onClick: (TabType) => void,
}

const Tab = ({ id, children, active, onClick }: Props): Node => {
  const handleClickTab = useCallback(() => {
    onClick(id);
  }, [id, onClick]);

  return (
    <PlainButtonAsLink
      className={styles.root}
      linkClassName={cx(styles.link, { active })}
      onClick={handleClickTab}
    >
      <PlainTooltip
        className={styles.linkContent}
        text={children}
        hideWithoutOverflow
      >
        {children}
      </PlainTooltip>
    </PlainButtonAsLink>
  );
};

export default Tab;
